var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEdgeware(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.000000, 40.000000)",
    stroke: "currentColor",
    strokeWidth: 22
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.5,0.5 L52.5,120.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5,0.5 L52.5,120.5",
    transform: "translate(52.500000, 60.500000) rotate(60.000000) translate(-52.500000, -60.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5,0.5 L52.5,120.5",
    transform: "translate(52.500000, 60.500000) rotate(-60.000000) translate(-52.500000, -60.500000) "
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdgeware);
export default __webpack_public_path__ + "static/media/edgeware.371f7bb0ab28e169f6ad295e102fc65f.svg";
export { ForwardRef as ReactComponent };